export default "__VITE_ASSET__Drud1KXC__"